module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('pulse-loader')], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('h2', [_vm._v("Processing")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1a24c178!./~/vue-loader/lib/selector.js?type=template&index=0!./src/tools/Modal.vue
// module id = 101
// module chunks = 1